import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-sankey', 'IconChartSankey', [
  ['path', { d: 'M3 3v18h18', key: 'svg-0' }],
  ['path', { d: 'M3 6h18', key: 'svg-1' }],
  ['path', { d: 'M3 8c10 0 8 9 18 9', key: 'svg-2' }],
]);
